import React, { useState, useRef, useEffect } from "react";
import { Button, Container, Dropdown, Card } from "react-bootstrap";
import Header2 from "../component/Header2";
import MapList from "../assets/images/view-icon/map-list.svg";
import Map from "../assets/images/view-icon/map.svg";
import List from "../assets/images/view-icon/list.svg";
import Like from "../assets/images/like.svg";
import bed from "../assets/images/bed.svg";
import bath from "../assets/images/bath.svg";
import size from "../assets/images/scale.svg";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import {
  SEARCH_PROPERTIES,
  SEARCH_PROPERTIES_WITH_FILTERS,
} from "../api/constants";
import useFavoritesList from "../hooks/useFavoritesList";
import power from "../assets/images/power.svg";
import storey from "../assets/images/storey.svg";
import { formatRentalPeriod } from "../utils/formatRentalPeriod";
import { useLocation } from "react-router-dom";
import FilterBar from "../component/FilterBar";
import usePropertySort from "../hooks/usePropertySort";
import SearchHeader from "../component/SearchHeader";

function Search() {
  const location = useLocation();

  const { isFavorite, toggleFavorite } = useFavoritesList();

  const [view, setView] = useState("both");
  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const [resultHeight, setResultHeight] = useState("60vh");
  const [sort, setSort] = useState("Sort by");

  const [selectedSuburb, setSelectedSuburb] = useState(() => {
    // ✅ Always use the full string saved by FilterBar
    return sessionStorage.getItem("fullSuburb") || "";
  });
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCounty, setSelectedCounty] = useState("");
  const [selectedCategory, setCategory] = useState("");
  const [selectedListingType, setListingType] = useState("");
  const [county, setCounty] = useState("");

  const [isQuickSearch, setIsQuickSearch] = useState(false);
  //Listings
  const [search_results, setSearchResults] = useState([]);
  const mapQuery = (() => {
  const params = new URLSearchParams(window.location.search);
  return (
    params.get("suburb") ||
    params.get("city") ||
    params.get("county") ||
    sessionStorage.getItem("fullSuburb") ||
    ""
  );
})();

  const getSearchResults = async () => {
    try {
      let filters = null;
      let quickSearch = false; // local flag

      // 1️⃣ Quick search (URL params)
      const params = new URLSearchParams(window.location.search);
      const suburbFromUrl = params.get("suburb");


   const cityFromUrl = params.get("city");
      const countyFromUrl = params.get("county");
      const categoryFromUrl = params.get("category");
      const listingTypeFromUrl = params.get("listing_type");

      if (suburbFromUrl) {
        filters = { suburb: suburbFromUrl };
        quickSearch = true; // set local flag
        setIsQuickSearch(true); // update state for UI
        //setSelectedSuburb(suburbFromUrl);
      } else if (cityFromUrl) {
        filters = { city: cityFromUrl };
        quickSearch = true; // set local flag
        setIsQuickSearch(true); // update state for UI
        setSelectedCity(cityFromUrl);
      } else if (countyFromUrl) {
        filters = { county: countyFromUrl };
        quickSearch = true; // set local flag
        setIsQuickSearch(true); // update state for UI
        setSelectedCounty(countyFromUrl);
      }

      // 2️⃣ Deep search (navigation state)
      else if (location.state?.filters) {
        filters = location.state.filters;
        sessionStorage.setItem("searchFilters", JSON.stringify(filters));
      }

      // 3️⃣ Refresh fallback (sessionStorage)
      else {
        const stored = sessionStorage.getItem("searchFilters");
        if (stored) {
          filters = JSON.parse(stored);
        }
      }

      if (!filters) {
        setSearchResults([]);
        return;
      }
      if(county!="" || county!=null) {
        setCounty(filters.suburb)
      }
      console.log("Final search filters:", filters.suburb);
      console.log("Quick search flag:", county);

      let res;

      // 🔹 QUICK SEARCH → GET
      if (quickSearch) {
        let url = `${SEARCH_PROPERTIES}?suburb=${encodeURIComponent(
          filters.suburb,
        )}`;
        if (cityFromUrl) {
          url = `${SEARCH_PROPERTIES}?city=${encodeURIComponent(filters.city)}`;
          if (categoryFromUrl) {
            setCategory(categoryFromUrl);
            url = `${SEARCH_PROPERTIES}?city=${encodeURIComponent(
              filters.city,
            )}&category=${categoryFromUrl}`;
            if (listingTypeFromUrl) {
              setCategory(categoryFromUrl);
              url = `${SEARCH_PROPERTIES}?city=${encodeURIComponent(
                filters.city,
              )}&category=${categoryFromUrl}&listing_type=${listingTypeFromUrl}`;
            }
          }
        } else if (countyFromUrl) {
          url = `${SEARCH_PROPERTIES}?county=${encodeURIComponent(
            filters.county,
          )}`;
        }
        console.log(url);
        res = await fetch(url);
      }

      // 🔹 DEEP SEARCH → POST
      else {
        res = await fetch(SEARCH_PROPERTIES_WITH_FILTERS, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(filters),
        });
      }

      const data = await res.json();

      if (data?.status && Array.isArray(data.data)) {
        setSearchResults(data.data);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Search error:", err);
      setSearchResults([]);
    }
  };

  useEffect(() => {
    const updateHeight = () => {
      const headerH = headerRef.current?.offsetHeight || 0;
      const filterH = filterRef.current?.offsetHeight || 0;
      const h = Math.max(0, window.innerHeight - headerH - filterH);
      setResultHeight(`${h}px`);
    };
    updateHeight();
    getSearchResults();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const sortedResults = usePropertySort(search_results, sort);

  const mapVisible = view === "both" || view === "map";
  const listVisible = view === "both" || view === "list";

  return (
    <>
      <div className="buy-main">
        <div ref={headerRef}>
          <Header2 />
        </div>
        <div className="buy-filter" ref={filterRef}>
          <div className="view-box">
            <div className="filter-group">
              <Button
                className={`map-list d-none d-md-flex ${view === "both" ? "active" : ""}`}
                onClick={() => setView("both")}
                aria-pressed={view === "both"}
              >
                <img src={MapList} alt="" />
              </Button>
              <Button
                className={`map ${view === "map" ? "active" : ""}`}
                onClick={() => setView("map")}
                aria-pressed={view === "map"}
              >
                <img src={Map} alt="" />
              </Button>
              <Button
                className={`list ${view === "list" ? "active" : ""}`}
                onClick={() => setView("list")}
                aria-pressed={view === "list"}
              >
                <img src={List} alt="" />
              </Button>
            </div>
          </div>
          <FilterBar
            onSuburbChange={(suburb) => setCounty(suburb)}
            onFullSuburbChange={(full) => {
              setSelectedSuburb(full);
              sessionStorage.setItem("fullSuburb", full); // keep in sync
            }}
          />
        </div>
        <div className="result-box" style={{ height: resultHeight }}>
          <div
            className="result-map"
            style={{
              animation: mapVisible
                ? "slideInLeft 0.4s ease-in-out forwards"
                : "slideOutRight 0.4s ease-in-out forwards",
              flex:
                view === "both" ? "1" : view === "map" ? "1 1 100%" : "0 0 0",
              overflow: "hidden",
              minHeight: 0,
              display: mapVisible ? "flex" : "none",
            }}
          >
            <iframe
              title="Google Maps"
              style={{ width: "100%", height: "100%", border: 0 }}
             src={`https://maps.google.com/maps?q=${encodeURIComponent(mapQuery + ", Kenya")}&output=embed`}

              allowFullScreen
              loading="lazy"
            />
          </div>
          <div
            className={`result-list ${view === "list" ? "list-open" : ""}`}
            style={{
              animation: listVisible
                ? "slideInRight 0.4s ease-in-out forwards"
                : "slideOutLeft 0.4s ease-in-out forwards",
              flex:
                view === "both" ? "1" : view === "list" ? "1 1 100%" : "0 0 0",
              overflowY: "auto",
              minHeight: 0,
              display: listVisible ? "block" : "none",
            }}
          >
            <div className="result-list-header d-flex justify-content-between align-items-center">
              <SearchHeader />

              <span>
                {sortedResults.length} result
                {sortedResults.length === 1 ? "" : "s"}
              </span>
              <Dropdown align="end" onSelect={(key) => key && setSort(key)}>
                <Dropdown.Toggle id="sort-dropdown">
                  {sort === "Sort by" ? <>Sort by</> : <>{sort}</>}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {[
                    "Price (High to Low)",
                    "Price (Low to High)",
                    "Newest",
                    "Bedrooms",
                    "Bathrooms",
                    "Square Feet",
                  ].map((opt) => (
                    <Dropdown.Item
                      key={opt}
                      eventKey={opt}
                      active={sort === opt}
                    >
                      {opt}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <ul>
              {sortedResults?.map((item) => (
                <li key={item.id}>
                  <Link
                    to={
                      item.listing_type === "rent" &&
                      item.property_type === "residential"
                        ? `/rent-details/${item.slug}`
                        : item.property_type === "commercial"
                          ? `/commercial-details/${item.slug}`
                          : `/buy-details/${item.slug}`
                    }
                  >
                    <div className="result-item-img position-relative">
                      <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={20}
                        centeredSlides={true}
                        slidesPerGroup={1}
                        // loop={true}
                        // autoplay={{ delay: 2500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                      >
                        {item.images.length > 0 &&
                          item.images.slice(0, 3).map((url, idx) => (
                            <SwiperSlide key={idx}>
                              <Card className="border-0">
                                <Card.Img src={url.image} />
                              </Card>
                            </SwiperSlide>
                          ))}
                      </Swiper>

                      {item.tag && (
                        <span className="recommended">{item.tag}</span>
                      )}
                      <span
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        className={`wishlist ${isFavorite(item.id) ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFavorite(item.id);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") toggleFavorite(item.id);
                        }}
                      >
                        <img src={Like} alt="like" />
                      </span>
                    </div>
                    <div className="result-item-info">
                      {item.listing_type === "rent" ? (
                        <h2>
                          KES{item.price}
                          <span className="rental-period">
                            {formatRentalPeriod(item.rental_term)}
                          </span>
                        </h2>
                      ) : (
                        <h2>KES{item.price}</h2>
                      )}

                      <p>{item.street_address}</p>
                      <div className="info-box">
                        {item.property_type === "residential" ? (
                          <>
                            <span>
                              <img src={bed} alt="" />{" "}
                              {item.details?.bedrooms ?? 0}
                            </span>
                            <span>
                              <img src={bath} alt="" />{" "}
                              {item.details?.bathrooms ?? 0}
                            </span>
                          </>
                        ) : (
                          <>
                            <span>
                              <img src={storey} alt="" />{" "}
                              {item.details?.floor_count}
                            </span>
                            <span>
                              <img src={power} alt="" />{" "}
                              {item.details?.power_capacity_kva}
                            </span>
                          </>
                        )}

                        <span>
                          <img src={size} alt="" /> {item.size_sqft}
                        </span>
                      </div>
                      <h6>
                        Listing by : <span>{item.listing_by?.name}</span>
                      </h6>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Container></Container>
      </div>
    </>
  );
}

export default Search;
